import { render, staticRenderFns } from "./TitleWithPenSwitcherMath.vue?vue&type=template&id=e552b6b8&scoped=true&lang=pug&"
import script from "./TitleWithPenSwitcherMath.vue?vue&type=script&lang=ts&"
export * from "./TitleWithPenSwitcherMath.vue?vue&type=script&lang=ts&"
import style0 from "./TitleWithPenSwitcherMath.vue?vue&type=style&index=0&id=e552b6b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e552b6b8",
  null
  
)

export default component.exports